import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/quote.svg';

const TestimonialsBlock = {
  id: 'testimonials',
  title: 'Testimonials',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default TestimonialsBlock;
